import * as yup from 'yup';

export const rules = yup.object().shape({
  gitlabProjectId: yup
    .number()
    .required('Repository id is required'),
});
